import MDEditor from "@uiw/react-md-editor/nohighlight";
import rehypeSanitize from "rehype-sanitize";
import React from "react";
import QuestionItem from "./QuestionItem";
import i18n from "../../../i18n";
import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from "../../../i18n/constants";

const FormPrint = ({ form, breakPage, langCode }: any) => {
  // Table headers must follow the language chosen for this print job, not the
  // admin's current app UI language, so fetch a fixed translator instead of useTranslation().
  const resolvedLang = SUPPORTED_LANGUAGES.includes(langCode)
    ? langCode
    : DEFAULT_LANGUAGE;
  const tPrint = i18n.getFixedT(resolvedLang, "responses");
  const questionHeader = tPrint(
    "SURVEY.PRINT_TABLE_QUESTION_HEADER"
  ) as string;
  const answersHeader = tPrint("SURVEY.PRINT_TABLE_ANSWERS_HEADER") as string;
  const noQuestionsLabel = tPrint("SURVEY.PRINT_NO_QUESTIONS") as string;
  const groupLabel = tPrint("SURVEY.PRINT_GROUP_LABEL") as string;
  const variableLabel = tPrint("SURVEY.PRINT_VARIABLE_LABEL") as string;
  const groupMemberSuffix = tPrint(
    "SURVEY.PRINT_GROUP_MEMBER_SUFFIX"
  ) as string;

  return (
    <div
      className="print-form-container"
      style={{
        pageBreakBefore: breakPage ? "always" : "auto",
      }}
    >
      <h2 style={{ marginBottom: "20px", lineHeight: "150%" }}>
        {form?.name || ""}
      </h2>
      <table className="print-crf-table">
        <thead>
          <tr className="crf-table-header">
            <th style={{ width: "14%" }}>#</th>
            <th style={{ width: "41%" }}>{questionHeader}</th>
            <th style={{ width: "45%" }}>{answersHeader}</th>
          </tr>
        </thead>
        <tbody>
          {form?.questions
            ?.filter((q: any) => q.isVisible && !q.properties.isHidden)
            ?.map((q: any, index: number) => {
              const isGroup = q.type === "group";
              const isGroupMember = !!q.groupQuestionId;
              return (
                <React.Fragment key={q.id}>
                  <tr
                    key={q.id + "-main"}
                    className="crf-table-row"
                    style={
                      isGroup
                        ? { backgroundColor: "#F5F8FD" }
                        : isGroupMember
                        ? { backgroundColor: "#FAFBFE" }
                        : undefined
                    }
                  >
                    {![
                      "statement",
                      "summary",
                      // "calculated_field",
                      "repeated_measure",
                      "group",
                    ].includes(q.type) ? (
                      <td
                        style={{
                          wordBreak: "break-word",
                          ...(isGroupMember ? { paddingLeft: 28 } : {}),
                        }}
                      >
                        {q?.properties?.displayNumber
                          ? q?.properties?.displayNumber
                          : index + 1}
                      </td>
                    ) : (
                      <td></td>
                    )}
                    <td
                      colSpan={
                        [
                          "statement",
                          "summary",
                          "repeated_measure",
                          "grid",
                          "repeated_data",
                          "group",
                        ].includes(q.type)
                          ? 2
                          : 1
                      }
                      style={isGroupMember ? { paddingLeft: 28 } : undefined}
                    >
                      <MDEditor.Markdown
                        wrapperElement={{
                          "data-color-mode": "light",
                        }}
                        source={q.label}
                        rehypePlugins={[rehypeSanitize]}
                        style={{ fontWeight: isGroup ? "600" : "400" }}
                      />
                      {(isGroup || isGroupMember) && (
                        <i style={{ fontSize: "14px" }}>
                          {isGroup ? groupLabel : `${variableLabel}: ${q.varname}`}
                          {isGroupMember ? ` · ${groupMemberSuffix}` : ""}
                        </i>
                      )}
                      {/* <i style={{ fontSize: "14px" }}>
                        Variable: {q.varname}
                        {q.dependency && (
                          <>
                            {" "}
                            | <DependencyItem dep={q.dependency} />
                          </>
                        )}
                      </i> */}
                    </td>
                    {![
                      "statement",
                      "summary",
                      "repeated_measure",
                      "grid",
                      "repeated_data",
                      "group",
                    ].includes(q.type) && (
                      <td>
                        <QuestionItem question={q} />
                      </td>
                    )}
                  </tr>
                  {["grid", "repeated_data"].includes(q.type) && (
                    <tr key={q.id + "table"} className="crf-table-row">
                      <td></td>
                      <td colSpan={2}>
                        <QuestionItem question={q} />
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              );
            })}
        </tbody>
      </table>
      {form?.questions?.length === 0 && (
        <h3 style={{ marginTop: "20px", textAlign: "center" }}>
          {noQuestionsLabel}
        </h3>
      )}
    </div>
  );
};

export default FormPrint;
